import React, { useState, useEffect } from 'react';
import NumberChooserAndTracker from './NumberChooserAndTracker';

import {
  MAX_PRICING_QUOTE_PRICES,
  MIN_SAMPLE_SIZE,
  MAX_SAMPLE_SIZE,
  AT_LEAST_ONE_LOCATION_TOOLTIP,
} from './utils';

const MAX_SAMPLE_SIZES_TOOLTIP =
  "You've reached the max number of sample sizes you can add";
const SAMPLE_SIZE_ALREADY_TOOLTIP = 'Sample size already added';

const LABEL = `Choose up to ${MAX_PRICING_QUOTE_PRICES} sample sizes (${MIN_SAMPLE_SIZE} - ${MAX_SAMPLE_SIZE})`;

export default function SampleSizeChooser({
  setSampleSizeToAdd,
  addSampleSize,
  canAddMoreSampleSizes,
  isLoading,
  sampleSizes,
  setSampleSizes,
  calculatedMaxRecommendedSampleSize,
  sampleSizeToAdd,
}: {
  setSampleSizeToAdd: React.Dispatch<React.SetStateAction<number>>;
  addSampleSize: () => void;
  canAddMoreSampleSizes: boolean;
  isLoading: boolean;
  sampleSizes: number[];
  setSampleSizes: (sampleSizes: number[]) => void;
  calculatedMaxRecommendedSampleSize: number;
  sampleSizeToAdd: number;
}) {
  const [addSampleSizeTooltip, setAddSampleSizeTooltip] = useState(
    AT_LEAST_ONE_LOCATION_TOOLTIP,
  );
  useEffect(() => {
    if (sampleSizes.length === MAX_PRICING_QUOTE_PRICES) {
      setAddSampleSizeTooltip(MAX_SAMPLE_SIZES_TOOLTIP);
    } else if (sampleSizes.includes(sampleSizeToAdd)) {
      setAddSampleSizeTooltip(SAMPLE_SIZE_ALREADY_TOOLTIP);
    } else {
      setAddSampleSizeTooltip(AT_LEAST_ONE_LOCATION_TOOLTIP);
    }
  }, [sampleSizes, sampleSizeToAdd]);
  return (
    <NumberChooserAndTracker
      label={LABEL}
      numberType="Sample Size"
      setNumberToAdd={setSampleSizeToAdd}
      addNumber={addSampleSize}
      addNumberTooltip={addSampleSizeTooltip}
      canAddMoreNumbers={canAddMoreSampleSizes}
      isLoading={isLoading}
      workingNumberList={sampleSizes}
      setNumberList={setSampleSizes}
      maxRecommendedNumber={calculatedMaxRecommendedSampleSize}
      minNumber={MIN_SAMPLE_SIZE}
      maxNumber={MAX_SAMPLE_SIZE}
    />
  );
}
